import { useMemo } from "react";
import type { IConfig } from "config/IConfig";
import createServices from "services/createServices";
import type { ITexts } from "translations/ITexts";
import type { ProfilePages } from "enums/ProfilePageTypes";
import type { IRequestNeededForServices } from "types/IRequestNeededForServices";

const useCreateServices = (
    configs: IConfig,
    texts: ITexts,
    page: ProfilePages,
    req: IRequestNeededForServices,
    searchWord?: string,
) =>
    useMemo(
        () => createServices(configs, texts, page, req as any, undefined, searchWord),
        [configs, page, texts, req, searchWord],
    );

export default useCreateServices;
